var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditCircled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 212836475"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 21,
    cy: 21,
    r: 20.5,
    fill: "white",
    stroke: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.3322 17.9268L23.0732 16.6678L14.7807 24.9604V26.2193H16.0396L24.3322 17.9268ZM25.5911 16.6678L26.85 15.4089L25.5911 14.15L24.3322 15.4089L25.5911 16.6678ZM16.7768 28H13V24.2223L24.9616 12.2607C25.1286 12.0938 25.355 12 25.5911 12C25.8272 12 26.0536 12.0938 26.2206 12.2607L28.7393 14.7794C28.9062 14.9464 29 15.1728 29 15.4089C29 15.645 28.9062 15.8714 28.7393 16.0384L16.7777 28H16.7768Z",
    fill: "#63658E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCircled);
export default __webpack_public_path__ + "static/media/editCircled.878009dd028bd5d56aca1bec9ad6c1cc.svg";
export { ForwardRef as ReactComponent };